import { type MenuProps } from 'antd'
import type { RouteItem } from 'route/routes'
import { routes } from 'route/routes'
import { Roles } from 'api/login-model'
import useRouterConfigStore from 'store/routerConfigStore'
import useUserStore from 'store/userStore'
import { useIntl } from "react-intl"
import meetingStore from "store/meetingStore"
import { MeetingProgress } from "api/meeting-model"

type MenuItem = Required<MenuProps>['items'][number]

const getMenu = (routes: RouteItem[]): MenuItem[] => {
  const intl = useIntl()

  const { meetingInfo } = meetingStore();
  const { loginInfo } = useUserStore.getState();

  const routeData = routes
    .filter(({ hidden }) => !hidden)
    .filter(({ roles }) => {
      if (Array.isArray(roles)) {
        return roles?.includes(loginInfo?.loginUser.roleInfo.roleKey as Roles)
      }
      return true
    });

  let dataTemp: any = [];
  routeData.forEach(route => {
    const { key, icon, children = [] } = route
    const subMenu = getMenu(children)
    const name = intl.formatMessage({ id: key })

    if (loginInfo?.loginUser.roleInfo.roleKey == Roles.Business) {
      if (meetingInfo?.meeting_progress! > MeetingProgress.NOT_STARTED && key == 'menu.meeting.configuration') {
      }
      else {
        dataTemp.push({
          key,
          label: name,
          data: route,
          icon: icon,
          children: subMenu.length > 0 ? subMenu : undefined
        });
      }
    }
    else {
      dataTemp.push({
        key,
        label: name,
        data: route,
        icon: icon,
        children: subMenu.length > 0 ? subMenu : undefined
      });
    }
  })

  return dataTemp as MenuItem[];
}

function getRouteByPath(path: string, routes: RouteItem[]): RouteItem | null {
  let result = null
  for (let i = 0; i < routes.length; i++) {
    const item = routes[i]
    if (item.path === path) {
      result = routes[i]
      break
    } else if (item.children) {
      result = getRouteByPath(path, item.children!)
    }
  }
  return result
}

export default function SiderMenu() {
  const navigate = useNavigate()
  const location = useLocation()
  const items: MenuItem[] =  getMenu(routes[1].children || [])
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])
  const { setCurrentRouterConfig } = useRouterConfigStore()
  const selectHandler: MenuProps['onSelect'] = ({
    selectedKeys,
    item: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      props: { data }
    }
  }) => {
    const { path } = data
    setSelectedKeys(selectedKeys)
    navigate(path)
    setCurrentRouterConfig(data)
  }

  useEffect(() => {
    const item = getRouteByPath(location.pathname, routes[1].children!)

    if (item) {
      setCurrentRouterConfig(item)
      setSelectedKeys([item.key])
    }
  }, [location.pathname, setCurrentRouterConfig])
  return (
    <Menu
      className="tw-border-0"
      mode="inline"
      defaultOpenKeys={['name-list']}
      selectedKeys={selectedKeys}
      items={items}
      onSelect={selectHandler}
    />
  )
}
